// extracted by mini-css-extract-plugin
export default {"submit-button":"FormSubmit_submit-button__kOeWh","back-button":"FormSubmit_back-button__cRzgm","wrapper":"FormSubmit_wrapper__IE-uv"};